import { client } from "./client";

const ROUTES = {
  getUserData: () => `/get_user_data/`,
  setUserInfo: () => `/set_user_info/`,
  createLead: () => `/create_lead/`,
  updateWelcomeTrialContract: () => `/update_welcome_trial_contract/`,
};

export const user = {
  getUserData: (auth) => {
    return client.get(ROUTES.getUserData(), auth);
  },
  setUserInfo: (form) => {
    return client.patch(ROUTES.setUserInfo(), form);
  },
  createLead: (form) => {
    return client.post(ROUTES.createLead(), form);
  },
  updateWelcomeTrialContract: (form) => {
    return client.post(ROUTES.updateWelcomeTrialContract(), form);
  },
};
